var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tx-pair-manage" },
    [
      _c("sec-title", {
        attrs: {
          title: _vm.$t("tradeTxPairManage.title", {
            tokenSymbol: _vm.tokenSymbol
          }),
          isShowHelp: false,
          isShowBack: true
        }
      }),
      _vm._v(" "),
      _c(
        "wallet-table",
        {
          staticClass: "tx-pair-manage-table",
          attrs: { headList: _vm.headList, contentList: _vm.showList }
        },
        [
          _vm._l(_vm.showList, function(v, i) {
            return _c("span", {
              key: i,
              class: "status-icon status_" + v.status,
              attrs: { slot: i + "statusTxtBefore" },
              slot: i + "statusTxtBefore"
            })
          }),
          _vm._v(" "),
          _vm._l(_vm.showList, function(v, i) {
            return _c(
              "span",
              {
                key: i,
                attrs: { slot: i + "operateBefore" },
                slot: i + "operateBefore"
              },
              [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: v.status === 3,
                        expression: "v.status === 3"
                      }
                    ],
                    staticClass: "__pointer click-able",
                    on: {
                      click: function($event) {
                        return _vm.openTxPair(v)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("tradeTxPairManage.openTxPair"))
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: v.status === 0,
                        expression: "v.status === 0"
                      }
                    ],
                    staticClass: "__pointer click-able",
                    on: {
                      click: function($event) {
                        return _vm.getIncomeList(v)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("tradeTxPairManage.historyIncome"))
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: v.status === 1,
                        expression: "v.status === 1"
                      }
                    ],
                    staticClass: "__pointer click-able",
                    on: {
                      click: function($event) {
                        return _vm.stopTx(v)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("tradeTxPairManage.stopTrans"))
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: v.status === 2,
                        expression: "v.status === 2"
                      }
                    ],
                    staticClass: "__pointer click-able",
                    on: {
                      click: function($event) {
                        return _vm.openTx(v)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("tradeTxPairManage.resetTrans"))
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: v.status === 1 || v.status === 2,
                        expression: "v.status === 1 || v.status === 2"
                      }
                    ],
                    staticClass: "__pointer click-able",
                    on: {
                      click: function($event) {
                        return _vm.changeFee(v)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("tradeTxPairManage.changeFee"))
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: v.status === 1 || v.status === 2,
                        expression: "v.status === 1 || v.status === 2"
                      }
                    ],
                    staticClass: "__pointer click-able",
                    on: {
                      click: function($event) {
                        return _vm.changeOwner(v)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("tradeTxPairManage.changeOwner"))
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: v.status === 1 || v.status === 2,
                        expression: "v.status === 1 || v.status === 2"
                      }
                    ],
                    staticClass: "__pointer click-able",
                    on: {
                      click: function($event) {
                        return _vm.getIncomeList(v)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("tradeTxPairManage.incomeList"))
                    )
                  ]
                )
              ]
            )
          }),
          _vm._v(" "),
          _c("pagination", {
            staticClass: "__tb_pagination",
            attrs: {
              slot: "tableBottom",
              totalPage: _vm.totalPage,
              toPage: _vm.fetchOperatorMarkets,
              currentPage: _vm.currentPage + 1
            },
            slot: "tableBottom"
          })
        ],
        2
      ),
      _vm._v(" "),
      _vm.showConfirmType === "incomeList"
        ? _c("income-list", {
            attrs: { close: _vm.closeConfirm, txPair: _vm.activeTxPair }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showConfirmType === "changeOwner"
        ? _c("change-owner", {
            attrs: {
              close: _vm.closeConfirm,
              txPair: _vm.activeTxPair,
              fetchConfig: _vm.fetchConfigTxPair
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showConfirmType === "changeFee"
        ? _c("change-fee", {
            attrs: {
              close: _vm.closeConfirm,
              txPair: _vm.activeTxPair,
              fetchConfig: _vm.fetchConfigTxPair
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showConfirmType === "openTxPair"
        ? _c("open-tx-pair", {
            attrs: { close: _vm.closeConfirm, txPair: _vm.activeTxPair }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }